export default "__VITE_ASSET__Ovq2I1ho__"